import React from "react";

import {Row, Col} from "react-bootstrap";
import {link as linkStyle, linkContainer as linkContainerStyle, container} from "./footer.module.css";
import obrasImg from "../content/obras.png";
import procesoCreativoImg from "../content/procesocreativo.png";
import creadoresImg from "../content/creadores.png";

export function Footer({style}) {
    return <Row className={`${style} ${container}`}>
    	<Link image={obrasImg} href={"/obras"}/>
	<Link image={procesoCreativoImg} href={"/proceso_creativo"}/>
	<Link image={creadoresImg} href={'/creadores'}/>
    </Row>;
}

function Link({image, alt, href}) {
    return <Col sm={12} md={4} className={linkContainerStyle}>
	<a href={href}><img className={linkStyle} src={image} alt={alt}/></a>
	</Col>;
}
